const _ = require('lodash');
const cheerio = require('cheerio');
const md = require('./markdown/index');

const renderMarkdown = (markdown) => {
  const rendered = md.render(markdown.toString());
  const markdownText = cheerio.load(rendered).text().trim();
  const markdownTextSingleLine = markdownText.replace(/[\r\n]+/g, ' ');
  const markdownTextSnippet = _.truncate(markdownTextSingleLine, { length: 150 });

  return {
    rendered,
    markdownText,
    markdownTextSingleLine,
    markdownTextSnippet,
  };
};

module.exports = {
  md,
  renderMarkdown,
};
